/* eslint-disable no-useless-escape */
import {NumberMaskProps} from './components/atoms/Input/types';

// RegExp
export const US_ZIP_REGEXP = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const DATE_OF_BIRTH_REGEXP =
  /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
export const PO_BOX_REGEX =
  /^ *((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[.]? *-?((box|bin|office)|b|(#|num)?\d+))|(p(ost|ostal)[.]? *(o(ff(ice)?)?)? *((box|bin|office)|b)? *\d+)|(p *-?\/?(o)? *-?(box|office))|post office (box|bin)|postal*\d+)/i;
export const NO_SYMBOLS_NO_NUMBERS_REGEXP = /^[A-Za-z. ]+$/;
export const NO_SYMBOLS_REGEXP = /^[0-9A-Za-z. ]+$/;
export const NO_SYMBOLS_ADDRESS_REGEXP = /^[A-Za-z0-9'.\-\s,]+$/;
export const VALID_EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const VALID_URL_REGEXP =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
// Input Masks
export const PHONE_MASK = [
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const ZIP_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const DATE_OF_BIRTH_MASK = [
  /[\d|*]/,
  /[\d|*]/,
  ' ',
  '/',
  ' ',
  /[\d|*]/,
  /[\d|*]/,
  ' ',
  '/',
  ' ',
  /[\d|*]/,
  /[\d|*]/,
  /[\d|*]/,
  /[\d|*]/,
];

export const SOCIAL_SECURITY_NUMBER_MASK = [
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  '-',
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  '-',
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
];

export const DATE_PICKER_MASK = [
  /[0-1]/,
  /\d/,
  '/',
  /[0-3]/,
  /\d/,
  '/',
  /[1-2]/,
  /\d/,
  /\d/,
  /\d/,
];

export const TAX_ID_NUMBER_MASK = [
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
  ' ',
  /\d/,
];

export const SOCIAL_SECURITY_NUMBER_HIDDEN_MASK: (string | RegExp)[] = [
  /[\d|*]/,
  ' ',
  /[\d|*]/,
  ' ',
  /[\d|*]/,
  ' ',
  '-',
  ' ',
  /[\d|*]/,
  ' ',
  /[\d|*]/,
  ' ',
  '-',
  ' ',
  /[\d|*]/,
  ' ',
  /[\d|*]/,
  ' ',
  /[\d|*]/,
  ' ',
  /[\d|*]/,
];

export const CURRENCY_MASK_OPTIONS: NumberMaskProps = {
  prefix: '$',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: false,
  allowNegative: false,
  allowLeadingZeroes: false,
};

export const NUMBER_MASK_OPTIONS: NumberMaskProps = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: false,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  allowNegative: false,
  allowLeadingZeroes: false,
};
